import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  sidebarIsActive: true,
}

export const layoutSlice = createSlice({
  name: 'layout',
  initialState,
  reducers: {
    setSidebarIsActive: (state, action) => {
      state.sidebarIsActive = action.payload.sidebarIsActive
    }
  }
})

export const { setSidebarIsActive } = layoutSlice.actions

export default layoutSlice.reducer
